export const REQUEST_INBOX_ACTION_FETCH = "request_inbox_action_fetch"
export const FETCH_INBOX_ACTION_SUCCESS = "fetch_inbox_action_success"
export const FETCH_INBOX_ACTION_FAILURE = "fetch_inbox_action_failure"

export const CLEAR_FETCH_INBOX_ACTION_STATES = "clear_inbox_action_states"